




































import { StatusDoProtocoloEnum } from '@/types/interfaces/protocolo/status-do-protocolo.enum'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ComponentSeloProtocolo extends Vue {
  @Prop({ default: false }) small: boolean
  @Prop({ default: false }) segueOProtocoloStatus: StatusDoProtocoloEnum

  get canShowAnySelo() {
    return !!this.segueOProtocoloStatus
  }

  get canShowSegueOProtocolo() {
    return this.segueOProtocoloStatus === StatusDoProtocoloEnum.segueOProtocolo
  }

  get canShowNaoSegueOProtocolo() {
    return this.segueOProtocoloStatus === StatusDoProtocoloEnum.naoSegueOProtocolo
  }

  get canShowTemProtocoloDisponivel() {
    return this.segueOProtocoloStatus === StatusDoProtocoloEnum.temProtocoloDisponivel
  }

  get fidelizationHasAcceptedDoctorJustificationStatus(): boolean {
    return this.segueOProtocoloStatus === StatusDoProtocoloEnum.fidelizacaoAceitouJustificativaMedico
  }

  get labelColor() {
    const classes: string[] = []

    if (this.small) {
      classes.push('-small')
    }

    if (this.canShowNaoSegueOProtocolo) {
      classes.push('-danger')
    }

    if (this.canShowTemProtocoloDisponivel) {
      classes.push('-yellow')
    }

    if (this.fidelizationHasAcceptedDoctorJustificationStatus) {
      classes.push('-blue')
    }

    return classes
  }
}
